import React, { useState } from 'react';
import api from '../services/api';
import './UneteFotografos.css';

const UneteFotografos = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    ciudad: '',
    equipoFotografico: '',
    experiencia: ''
  });
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setEnviando(true);
    try {
      await api.post('/fotografos/solicitud', formData);
      setEnviado(true);
    } catch (err) {
      setError(err.response?.data?.message || 'No se pudo enviar tu solicitud. Intenta de nuevo.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="unete-container">
      <div className="unete-content">
        <div className="unete-hero">
          <h1>📷 Únete como Fotógrafo</h1>
          <p>
            Cubrimos carreras y eventos deportivos. Si tienes cámara propia y quieres
            generar ingresos extra fotografiando eventos, déjanos tus datos y te contactamos.
          </p>
        </div>

        <div className="unete-card">
          {enviado ? (
            <div className="unete-exito">
              <h2>✅ ¡Listo!</h2>
              <p>Recibimos tu información. Te vamos a contactar por WhatsApp muy pronto.</p>
            </div>
          ) : (
            <form className="unete-form" onSubmit={handleSubmit}>
              {error && <div className="unete-error">{error}</div>}

              <div className="form-group">
                <label>Nombre completo *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  placeholder="Tu nombre"
                />
              </div>

              <div className="form-group">
                <label>Teléfono / WhatsApp *</label>
                <input
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  required
                  placeholder="10 dígitos"
                />
              </div>

              <div className="form-group">
                <label>Ciudad / zona donde te mueves</label>
                <input
                  type="text"
                  name="ciudad"
                  value={formData.ciudad}
                  onChange={handleChange}
                  placeholder="Ej. Guadalajara, Zapopan..."
                />
              </div>

              <div className="form-group">
                <label>¿Qué equipo fotográfico tienes?</label>
                <input
                  type="text"
                  name="equipoFotografico"
                  value={formData.equipoFotografico}
                  onChange={handleChange}
                  placeholder="Marca/modelo de cámara, lentes, etc."
                />
              </div>

              <div className="form-group">
                <label>Cuéntanos tu experiencia (opcional)</label>
                <textarea
                  name="experiencia"
                  value={formData.experiencia}
                  onChange={handleChange}
                  placeholder="Eventos que has cubierto, años tomando fotos, etc."
                />
              </div>

              <button type="submit" className="unete-submit" disabled={enviando}>
                {enviando ? 'Enviando...' : 'Enviar mi información'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default UneteFotografos;
